module.exports = __webpack_public_path__ + "static/img/4.e293f519.png";